import {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, Container, CircularProgress} from '@material-ui/core';
import Stepper from './component/Stepper';
import SecondStep from './component/SecondStep';
import ThirdStep from './component/ThirdStep';
import FinalStep from './component/FinalStep';
import Context from './store/store';
import axios from 'axios';
import { __ } from '@wordpress/i18n';
import qs from 'qs';
const useStyles = makeStyles((theme) => ({
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));
function App(props) {
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        licenseCode: '',
        mwb_enable_acfw: true,
        mwb_enable_atc_popup : true,
        mwb_acfw_cut_off_time: 1,
        checkedB: false,
        consetCheck:'yes',
        abcName:'',
        mwb_atc_text:'',
        mwb_atc_title:'',        
    });
    
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const steps = [ __( 'General Settings', 'abandoned-cart-for-woocommerce' ), __( 'Pop-Up Setting', 'abandoned-cart-for-woocommerce' ),  __( 'Final Step', 'abandoned-cart-for-woocommerce' )];

    
    const onFormFieldHandler = (event) => {
        let value = ('checkbox' === event.target.type ) ? event.target.checked : event.target.value;
        setState({ ...state, [event.target.name]: value });
    };
    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            
            case 0:
                return (<ThirdStep/>);
            case 1:
                return <SecondStep />;
            case 2:
            return <FinalStep />;
            case 3:
                return <h1>{__( 'Thanks for your details', 'abandoned-cart-for-woocommerce' )}</h1>;
            default:
                return __( 'Unknown stepIndex', 'abandoned-cart-for-woocommerce' );
        }
    }
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const user = {
            ...state,
            'action': 'acfw_mwb_standard_save_settings_filter',
            nonce: frontend_ajax_object.mwb_standard_nonce,   // pass the nonce here
        };
        
        axios.post(frontend_ajax_object.ajaxurl, qs.stringify(user) )
            .then(res => {
                setLoading(false);
                console.log( res.data);
                handleNext();
                setTimeout(() => {
                  window.location.href = frontend_ajax_object.redirect_url; 
                    return null;
                }, 3000);
            }).catch(error=>{
                console.log(error);
        })
        
    }

    let nextButton = (
        <Button
            variant="contained" color="primary" onClick={handleNext} size="large">
            Next
        </Button>
    );
    if (activeStep === steps.length-1 ) {
        nextButton = (
            <Button
                onClick={handleFormSubmit}
                variant="contained" color="primary" size="large">
                Finish
            </Button>
        )
    } 
    return (
        <Context.Provider value={{
            formFields:state,
            changeHandler:  onFormFieldHandler,  
        }}>
            <div className="mwbMsfWrapper">
                <Stepper activeStep={activeStep} steps={steps}/>
                <div className="mwbHeadingWrap">
                    <h2>{__( 'Welcome to Makewebbetter', 'abandoned-cart-for-woocommerce' ) }</h2>
                    <p>{__('Complete The steps to get started','abandoned-cart-for-woocommerce') }</p>
                </div>
                <Container maxWidth="sm">
                    <form className="mwbMsf">
                        <Typography className={classes.instructions}>
                            {(loading) ? <CircularProgress className="mwbCircularProgress" /> :getStepContent(activeStep)}
                        </Typography>
                        <div className="mwbButtonWrap">
                            {activeStep !== steps.length && <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                variant="contained" size="large">
                            Back
                            </Button>}
                            {activeStep !== steps.length && nextButton}
                        </div>
                    </form>
                </Container >
            </div>
        </Context.Provider>
    );
}

export default App;